import { t } from "@/i18n-js/instance";
import { ScreenFrame } from "@circle-react/components/LiveStreams/common/ScreenFrame";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import "./styles.scss";

export const LiveLoader = () => (
  <ScreenFrame>
    <div className="override-live-loader-svg-width mb-5">
      <Loader />
    </div>
    <div className="mb-4 text-center">
      <Typography.TitleXl color="text-white">
        {t("live_streams.room.loading.title")}
      </Typography.TitleXl>
    </div>
    <div className="mb-4 text-center">
      <Typography.LabelMd color="text-white">
        {t("live_streams.room.loading.subtitle")}
      </Typography.LabelMd>
    </div>
  </ScreenFrame>
);
